import React from 'react';
import { Badge } from './ui/badge';
import { resolveInputTypeLabel } from '../biosdkRoutes';

export default function InputTypeBadge({ fileExtensions = [], apiVariant, contextKey }) {
  const info = resolveInputTypeLabel(fileExtensions, apiVariant, contextKey);
  if (!info) return null;

  return (
    <div className="space-y-1">
      <Badge variant="outline">{info.label}</Badge>
      <p className="text-xs text-gray-500">{info.hint}</p>
    </div>
  );
}
